import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Gauge, Users, SignOut, ShieldCheck, Calendar, Warning, ClipboardText, ListChecks, FileText, CurrencyEur, ChartBar, MapTrifold, GasPump, Waves, RoadHorizon, Note as NoteIcon } from "@phosphor-icons/react";
import { useAuth } from "@/lib/auth";

function NavLink({ to, icon: Icon, label, testId, active }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`px-3 py-2 text-xs uppercase tracking-widest font-bold border transition-none inline-flex items-center gap-2 ${
        active
          ? "bg-black text-white border-black"
          : "bg-white text-black border-zinc-300 hover:border-[var(--ny-gold)] hover:text-[var(--ny-gold-deep)]"
      }`}
    >
      <Icon size={14} weight="bold" /> {label}
    </Link>
  );
}

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const isActive = (to) => location.pathname === to;

  return (
    <header className="bg-white border-b border-black" data-testid="app-header">
      <div className="ny-divider-thick" />
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-3 flex items-center justify-between gap-3 flex-wrap">
        <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
          <img
            src="/logo-ny-trans.png"
            alt="NY Trans"
            className="h-12 w-auto"
            style={{ filter: "drop-shadow(0 1px 0 rgba(0,0,0,0.05))" }}
          />
          <div className="hidden sm:block border-l border-zinc-300 pl-3">
            <div
              className="serif-display text-xl leading-none"
              style={{ color: "var(--ny-black)" }}
            >
              NY TRANS
            </div>
            <div className="label-tag mt-1">Contrôle de Flotte</div>
          </div>
        </Link>
        <nav className="flex items-center gap-2 flex-wrap">
          <NavLink to="/" icon={Gauge} label="Tableau" testId="nav-dashboard" active={isActive("/")} />
          <NavLink to="/attribution" icon={ListChecks} label="Attribution" testId="nav-attribution" active={isActive("/attribution")} />
          <NavLink to="/plan-vague" icon={Waves} label="Vagues" testId="nav-wave-plan" active={isActive("/plan-vague")} />
          <NavLink to="/notes" icon={NoteIcon} label="Notes" testId="nav-notes" active={isActive("/notes")} />
          <NavLink to="/calendrier" icon={Calendar} label="Calendrier" testId="nav-calendar" active={isActive("/calendrier")} />
          <NavLink to="/documents" icon={FileText} label="Documents" testId="nav-documents" active={isActive("/documents")} />
          <NavLink to="/primes" icon={CurrencyEur} label="Primes" testId="nav-primes" active={isActive("/primes")} />
          <NavLink to="/budget" icon={ChartBar} label="Budget" testId="nav-budget" active={isActive("/budget")} />
          <NavLink to="/consommation" icon={GasPump} label="Conso." testId="nav-consommation" active={isActive("/consommation")} />
          <NavLink to="/telepeages" icon={RoadHorizon} label="Télépéages" testId="nav-telepeages" active={isActive("/telepeages")} />
          <NavLink to="/amendes" icon={Warning} label="Amendes" testId="nav-amendes" active={isActive("/amendes")} />
          <NavLink to="/carte" icon={MapTrifold} label="Carte" testId="nav-fleet-map" active={isActive("/carte")} />
          <NavLink to="/sinistres" icon={Warning} label="Sinistres" testId="nav-claims" active={isActive("/sinistres")} />
          <NavLink to="/chauffeurs" icon={Users} label="Chauffeurs" testId="nav-drivers" active={isActive("/chauffeurs")} />
          {user?.role === "admin" && (
            <NavLink
              to="/utilisateurs"
              icon={ShieldCheck}
              label="Utilisateurs"
              testId="nav-users" active={isActive("/utilisateurs")} />
          )}
          {user?.role === "admin" && (
            <NavLink
              to="/journal"
              icon={ClipboardText}
              label="Journal"
              testId="nav-activity" active={isActive("/journal")} />
          )}
          {user && (
            <div className="flex items-center gap-2 pl-2 ml-1 border-l border-zinc-300">
              <div className="text-xs uppercase tracking-widest font-bold text-zinc-600 hidden md:block">
                {user.name || user.email}
              </div>
              <button
                onClick={() => {
                  logout();
                  navigate("/login");
                }}
                className="px-3 py-2 text-xs uppercase tracking-widest font-bold border border-zinc-300 hover:border-red-600 hover:text-red-600 inline-flex items-center gap-2"
                data-testid="logout-btn"
              >
                <SignOut size={14} weight="bold" /> Sortir
              </button>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
}
